import {
  ref, onMounted, onBeforeUnmount, computed,
} from '@vue/composition-api'
import notesApi from '@/http/requests/customers/notes'
import { transformDatetimeToHumanReadablePretty } from '@/helpers/dateTimeHelper'
import store from '@/store'

export default (props, { emit }) => {
  const me = computed(() => store.getters['auth/getUser'])
  const notes = ref([])
  const newNote = ref('')
  const loading = ref(false)
  const processing = ref(false)
  const offset = ref(0)
  const limit = 10
  const canLoadMore = ref(true)
  const infiniteScrollTrigger = ref(null)
  let observer

  const fetchNotes = () => {
    if (loading.value || !canLoadMore.value) return
    loading.value = true
    notesApi.getCustomerNotes(props.customer.id, { limit, offset: offset.value })
      .then(res => {
        notes.value = [...notes.value, ...res.data.items]
        offset.value += limit
        if (notes.value.length >= res.data.total) {
          canLoadMore.value = false
        }
      })
      .finally(() => {
        loading.value = false
      })
  }

  const addNote = () => {
    if (!newNote.value) return
    processing.value = true
    notesApi.postCustomerNote(props.customer.id, { note: newNote.value })
      .then(res => {
        notes.value.unshift(res.data)
        newNote.value = ''
      })
      .finally(() => {
        processing.value = false
      })
  }

  const deleteNote = note => {
    processing.value = true
    notesApi.deleteCustomerNote(props.customer.id, note.id)
      .then(() => {
        notes.value = notes.value.filter(n => n.id !== note.id)
      })
      .finally(() => {
        processing.value = false
      })
  }

  const authorName = note => {
    if (!note.user) return ''
    if (note.user.id === me.value.id) return ''
    return `${note.user.lastName} ${note.user.firstName}`
  }

  const loadMore = entries => {
    if (entries[0].isIntersecting) {
      fetchNotes()
    }
  }

  onMounted(() => {
    fetchNotes()
    observer = new IntersectionObserver(loadMore, { rootMargin: '100px' })
    if (infiniteScrollTrigger.value) observer.observe(infiniteScrollTrigger.value)
    emit('loaded')
  })

  onBeforeUnmount(() => {
    if (observer && infiniteScrollTrigger.value) observer.unobserve(infiniteScrollTrigger.value)
  })

  return {
    notes,
    newNote,
    loading,
    processing,
    addNote,
    deleteNote,
    authorName,
    transformDatetimeToHumanReadablePretty,
    infiniteScrollTrigger,
  }
}
